import { render, staticRenderFns } from "./FailedPoaTable.vue?vue&type=template&id=58d5abc3&"
import script from "./FailedPoaTable.vue?vue&type=script&lang=js&"
export * from "./FailedPoaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports